import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '../theme';
import { makeAuthStyles } from './authStyles';

// Placeholder instructions pages for the PureTrack / Pushover keys. The actual
// step-by-step content will be filled in later.
const TOPICS = {
  puretrack: {
    title: 'PureTrack key',
    body: 'Instructions for finding your PureTrack key will be added here.',
  },
  pushover: {
    title: 'Pushover user key',
    body: 'Instructions for finding your Pushover user key will be added here.',
  },
};

export default function InstructionsPage() {
  const { topic } = useParams();
  const { colors } = useTheme();
  const S = makeAuthStyles(colors);
  const navigate = useNavigate();
  const info = TOPICS[topic] || { title: 'Instructions', body: 'Content coming soon.' };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <h1 style={S.title}>{info.title}</h1>
        <p style={{ color: colors.text, fontSize: 14, lineHeight: 1.5, textAlign: 'center', margin: 0 }}>
          {info.body}
        </p>
        <button style={S.buttonAlt} type="button" onClick={() => navigate(-1)}>Back</button>
      </div>
    </div>
  );
}
